module.exports = __webpack_public_path__ + "assets/img/whisk_active.2f93912e.png";